/* eslint-disable no-unused-vars */

import SessionsList from '../../components/Reusable/SessionsList';
import { Button, Typography, Tabs } from 'antd';
import {
  Card,
  CardHeader,
  CardFooter,
  Container,
  Row,
  Spinner,
} from 'reactstrap';
import {
  useQueryParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';
import {
  Link,
  Switch,
  useRouteMatch,
  Route,
  Redirect,
  useHistory,
} from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { TabPane } = Tabs;

const { Title } = Typography;

export default function ChargingSessions() {
  const history = useHistory();
  const isLoading = false;
  const allFilters = [
    { name: 'All', key: 'all' },
    { name: 'Active Sessions', key: 'active' },
  ];

  const [filter, setFilter] = useState('');

  return (
    <>
      <Container className="" style={{ marginTop: 100 }} fluid>
        <Row>
          <div className="col">
            <Card className="shadow" style={{ minHeight: '400px' }}>
              <CardHeader
                className="border-0"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingBottom: 0,
                }}
              >
                <h3>
                  Charging Sessions{' '}
                  <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                    (Host)
                  </span>
                  {isLoading ? (
                    <Spinner
                      style={{
                        color: '#2675b8',
                        fontSize: '8px',
                        height: '20px',
                        width: '20px',
                        marginLeft: '15px',
                      }}
                    />
                  ) : null}
                </h3>
              </CardHeader>
              <hr style={{ margin: '5px' }} />
              <Tabs
                activeKey={filter}
                onTabClick={(key) => {
                  setFilter(key, 'push');
                }}
                className="w-full"
                style={{ marginLeft: 10 }}
              >
                {allFilters.map(({ name, key }) => (
                  <TabPane tab={name} key={key}>
                    <SessionsList filter={key} />
                  </TabPane>
                ))}
              </Tabs>

              {/* <CardFooter className="py-4">
                {chargers?.length > 0 &&
                getTotalNumOfPages(
                  toNumber(localStorage.getItem('pageTotalHostChargers')),
                  limit,
                ) > 1 ? (
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={
                        <div
                          style={{
                            border: '1px solid #e8ebee',
                            padding: '10px',
                            borderRadius: '50%',
                            width: '35px',
                            height: '35px',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            marginRight: '10px',
                          }}
                          onClick={() => {
                            if (!chargersPageNum === 1) {
                              setChargersPageNum(chargersPageNum - 1);
                            }
                          }}
                        >
                          <i
                            className="fas fa-angle-left"
                            style={{ color: '#94a3b3' }}
                          />
                        </div>
                      }
                      nextLabel={
                        <div
                          style={{
                            border: '1px solid #e8ebee',
                            padding: '10px',
                            borderRadius: '50%',
                            width: '35px',
                            height: '35px',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            marginLeft: '10px',
                          }}
                          onClick={() => {
                            if (
                              !(
                                calculatePageOffset(limit, chargersPageNum) +
                                  limit >=
                                (toNumber(
                                  localStorage.getItem('pageTotalHostChargers'),
                                ) || 0)
                              )
                            ) {
                              setChargersPageNum(chargersPageNum + 1);
                            }
                          }}
                        >
                          <i
                            className="fas fa-angle-right"
                            style={{ color: '#94a3b3' }}
                          />
                        </div>
                      }
                      pageRangeDisplayed={2}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      initialPage={chargersPageNum - 1}
                      pageCount={getTotalNumOfPages(
                        toNumber(localStorage.getItem('pageTotalHostChargers')),
                        limit,
                      )}
                      marginPagesDisplayed={2}
                      onPageChange={(data) => {
                        setChargersPageNum(data.selected + 1);
                      }}
                      disableInitialCallback={true}
                      containerClassName={classes.pagination}
                      pageClassName={classes.pageNum}
                      activeClassName={classes.activePageNum}
                    />
                  </nav>
                ) : null}
              </CardFooter> */}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
